<template>
  <div class="profileContainer">
    <profile-component />
  </div>
</template>

<script>
import ProfileComponent from "../../../components/b2b/dlcon/ProfileComponent";

export default {
  name: "dlconProfile",
  components: {ProfileComponent},
}
</script>

<style scoped>
.profileContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #D2D2D2;
}

</style>
